<template>
  <div>
    <v-container>
      <div
        v-if="!showAdd"
        @click="showAdd = true"
        class="add-conversation text-xs-center mb-3"
        style="cursor: pointer"
      >
        <i class="fa fa-plus middle"></i> Add Auction Post
      </div>
      <div
        v-else
        class="intent-item pa-0 mb-3"
        :style="`border: 1px solid ${$vuetify.theme.primary};`"
      >
        <AstonAuctionManager @onSave="onSave" @close="showAdd = false"></AstonAuctionManager>
      </div>
      <div v-if="loading" class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
      <div v-else>
        <h2 v-if="filteredData.length">On going</h2>
        <AstonAuctionItem
          v-for="item in filteredData"
          @updateData="updateData"
          :key="item.id"
          :item="item"
          :active="true"
        ></AstonAuctionItem>
        <h2 v-if="notActiveData.length">Finished</h2>
        <AstonAuctionItem
          v-for="item in notActiveData"
          :key="item.id"
          :item="item"
          :active="false"
        ></AstonAuctionItem>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AstonAuctionManager from './AstonAuctionManager.vue'
import AstonAuctionItem from './AstonAuctionItem.vue'
import api from '@/api'

export default {
  data() {
    return {
      data: [],
      showAdd: false,
      expand: [],
      loading: true
    }
  },
  components: {
    AstonAuctionManager,
    AstonAuctionItem
  },
  mounted() {
    this.getAuctions()
  },
  computed: {
    filteredData() {
      return this.data.filter(el => el.isactive)
    },
    notActiveData() {
      return this.data.filter(el => !el.isactive)
    },
    ...mapGetters({ selectedBot: 'selectedBot' })
  },
  methods: {
    onSave(data) {
      this.data.push({ ...data, isactive: true, expand: false })
      this.showAdd = false
    },
    getAuctions() {
      this.loading = true
      api.getauctionfbpost({ pageid: this.selectedBot.pageid }, (err, response) => {
        this.loading = false
        if (response.responsecode == 200 && response.data) {
          this.data = response.data.map(el => {
            return { ...el, expand: false }
          })
        }
      })
    },
    updateData(data) {
      var index = this.data.findIndex(el => el.id == data.id)
      this.data[index] = data
      this.$set(this.data, index, data)
    }
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AstonAuction.vue